import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import Typography from '@material-ui/core/Typography';
import React, { useEffect, useState } from 'react';
import { Row } from 'reactstrap';
import usePortalAuth from '../../../auth/usePortalAuth';
import { Box, Paper } from '@material-ui/core';

import useChangePageTitle from '../CustomHooks/useChangePageTitle';
import useCheckPermissionsForAPICalls from '../CustomHooks/useCheckPermissionsForAPICalls';
import useFilterForm from '../CustomHooks/useFilterForm';
import ScalableShieldSpinner from '../LoadingSpinner/ScalableShieldSpinner';
import AddMultipleUsersModal from './AddMultipleUsersModal';
import './UserManagement.css';
import UserManagementModal from './UserManagementModal';
import UserManagementTable from './UserManagementTable';
import basePCUrl from '../../../Globals';


const UserManagement = (props) => {
  useChangePageTitle('UserManagement');

  const [error, setError] = useState();
  const [retrievedUsers, setRetrievedUsers] = useState([]);
  const [isLoading, setLoading] = useState([]);
  const { getAccessTokenSilently, logout } = usePortalAuth();
  const uid = props.uid;

  // Clean up PCAT DOM element and perform logout
  const handleLogout = () => {
    // Clear localStorage items related to user session
    localStorage.removeItem('usid');
    // Perform provider logout
    logout({
      returnTo: 'https://portal.phishcloud.io/PortalSignIn',
    });
  };

  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation

  const accountForNullData = ['nullData'];

  const { requestType, callRoute } = useCheckPermissionsForAPICalls(props.accessLevel);

  const [values, handleFilterChange] = useFilterForm({
    filter: '',
  });

 
  if (props.selectedClient === undefined || props.selectedClient=== '') {
    var clientId = props.defaultClient;
  } else {
    var clientId = props.selectedClient;
  }

  const useStyles = makeStyles((theme) => ({
    root: {
      padding: theme.spacing(3),
      background: theme.palette.type === 'dark' ? theme.palette.background.default : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      minHeight: '100vh',
    },
  title: {
      fontWeight: 700,
      color: theme.palette.type === 'dark' ? theme.palette.text.primary : '#1a237e',
      marginBottom: theme.spacing(2),
      textAlign: 'center',
    },
    controls: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      alignItems: 'center',
      marginBottom: theme.spacing(3),
      padding: theme.spacing(3),
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 12,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
    },
    searchContainer: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    searchInput: {
      width: '100%',
      padding: '10px 36px 10px 15px',
      border: '2px solid #e0e0e0',
      borderRadius: 8,
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '14px',
      transition: 'all 0.3s ease',
      '&:focus': {
        outline: 'none',
        borderColor: '#0055A2',
        boxShadow: '0 0 0 3px rgba(0, 85, 162, 0.1)',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
        padding: '8px 32px 8px 12px',
      },
    },
    searchButton: {
      position: 'absolute',
      right: '4px',
      color: '#0055A2',
      transition: 'all 0.3s ease',
      padding: '8px',
      '&:hover': {
        color: '#061739',
      },
    },
    buttonGroup: {
      display: 'flex',
      gap: theme.spacing(1),
      flexShrink: 0,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        flexDirection: 'column',
      },
    },
    actionButton: {
      background: 'linear-gradient(45deg, #0055A2, #428BC9)',
      color: 'white',
      fontWeight: 600,
      '&:hover': {
        background: 'linear-gradient(45deg, #061739, #0055A2)',
      },
    },
    tableContainer: {
      padding: 0,
    },
    spinnerContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '400px',
    },
  }));

  const classes = useStyles();

  //----------Retrieve Users-------------//
  const retrieveUsers = async (finalClientId) => {
    const token = await getAccessTokenSilently();
    setLoading(true);

    fetch(basePCUrl, {
      method: 'GET',
      headers: {
        action: 'getUserList',
        'content-type': 'application/json',
        //testacct: uid,
        id: finalClientId,
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        response.json().then((data) => {
          if (Object.entries(data).includes('not able to verify access token or resolve to a valid user')) {
            handleLogout();
          } else if (data.users === null || data.users === undefined) {
            setRetrievedUsers(accountForNullData);
          } else {
            setRetrievedUsers(data.users);
            setLoading(false);
          }
        });
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
  };

  useEffect(() => {
    if (clientId != undefined) {
      retrieveUsers(clientId);
    } else {
      retrieveUsers('');
    }
  }, [clientId]);

  //-------Handle Search Filter-------//

  let filter = values.filter;
  const lowercasedFilter = filter.toLowerCase();

  //Filter out null values so Object.keys doesn't throw and error
  var noNullForFilter = retrievedUsers.map((el) => {
    return Object.keys(el).reduce((newObj, key) => {
      const value = el[key];
      if (value !== null) {
        newObj[key] = value;
      }
      return newObj;
    }, {});
  });

  const filteredData = noNullForFilter.filter((item) => {
    return Object.keys(item)
      .filter(Boolean)
      .some((key) => item[key].toString().toLowerCase().includes(lowercasedFilter));
  });

  return (
    <div className={classes.root}>
      <Paper className={classes.controls}>
        <Typography variant="h3" className={classes.title}>
          {getTranslation('User Management', preferredLanguage)}
        </Typography>
        <Box style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center', width: '100%' }}>
          <form id="userManagementSearchForm" style={{ display: 'flex', gap: 0, alignItems: 'center', flex: 1, minWidth: '300px' }}>
            <div className={classes.searchContainer}>
              <InputBase
                type="text"
                defaultValue=""
                placeholder="Search Users"
                id="userManagementSearchInput"
                name="filter"
                value={values.filter}
                onChange={handleFilterChange}
                className={classes.searchInput}
              />
              <Button disabled id="search" className={classes.searchButton}>
                <FontAwesomeIcon icon={['fas', 'search']} />
              </Button>
            </div>
          </form>

          <Box className={classes.buttonGroup}>
            <UserManagementModal
              retrieveUsers={retrieveUsers}
              requestType={requestType}
              callRoute={callRoute}
              clientId={clientId}
              accessLevel={props.accessLevel}
              uid={props.uid}
              preferredLanguage={props.preferredLanguage}
              getTranslation={props.getTranslation}
            />

            <AddMultipleUsersModal
              retrieveUsers={retrieveUsers}
              requestType={requestType}
              callRoute={callRoute}
              clientId={clientId}
              accessLevel={props.accessLevel}
              uid={props.uid}
              preferredLanguage={props.preferredLanguage}
              getTranslation={props.getTranslation}
            />
          </Box>
        </Box>
      </Paper>

      <Box className={classes.tableContainer}>
        {isLoading ? (
          <div className={classes.spinnerContainer}>
            <ScalableShieldSpinner size={150} logoSrc={require('../../../Assets/Logos/Shield.png')} />
          </div>
        ) : error === true ? (
          <Typography color="error">There was an error loading users</Typography>
        ) : (
          <UserManagementTable
            rows={filteredData}
            retrieveUsers={retrieveUsers}
            requestType={requestType}
            callRoute={callRoute}
            clientId={clientId}
            uid={props.uid}
            accessLevel={props.accessLevel}
            preferredLanguage={props.preferredLanguage}
            getTranslation={props.getTranslation}
          />
        )}
      </Box>
    </div>
  );
};
export default UserManagement;


/*

< AddMultipleUsersModal
retrieveUsers = { retrieveUsers } />

*/
